module.exports = __webpack_public_path__ + "static/media/home-hero-aleksey-18.1c136176.jpg";